import React, { Component } from 'react'
import { connect } from 'react-redux'
import TextIput from '../../../textInput'
import validation, { notEmpty, emailAddres, isValid, justNumber } from '../../../validations'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { get } from '../../../utils/networking'
import SelectInput from '../../common/selectInput'
import * as Notify from '../../../notification'
import VirtualizedSelect from 'react-virtualized-select';
import $ from 'jquery'
import { Route, NavLink, HashRouter } from "react-router-dom";

var validationData = {
    businessName: [notEmpty],
    zipCode: [notEmpty, justNumber]
}

export class StepTwo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            businessName: "",
            address1: "",
            address2: "",
            longtitude: 0,
            latitude: 0,
            geocodeResults: null,
            loading: false,
            options: {
                categories: []
            },
            isRegisted: false,
            zipCode: 0,
            currentAddressTab: 1,
            countrys: [],
            countryValue: null,
            states: [],
            stateValue: null,
            citys: [],
            cityValue: null,
            city: "",
            isProccessing: false
        }

    }


    handleSubmit() {
        Notify.hide();
        const value = {
            businessName: this.state.businessName,
            address1: this.state.address1,
            address2: this.state.address2,
            longtitude: this.state.longtitude,
            latitude: this.state.latitude,
            categoryID: this.refs.category_value.value,
            zipCode: this.state.zipCode,
            city: this.state.city,
            state: this.state.stateValue,
            country: this.state.countryValue
        }
        let {
            isProccessing
        } = this.props
        let final_address = $("#final_address").html()
        let url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + final_address.split(" ").join("%20") + '&key=AIzaSyDk17id-kgU2ZXd_LOq30TEsgsLAY45358';
        fetch(url)
            .then(res => res.json()
                .then((out) => {
                    value.longtitude = out.results[0].geometry.location.lng;
                    value.latitude = out.results[0].geometry.location.lat;
                    if (isValid(validationData) && !isProccessing) {
                        this.props.callback(value);
                    }
                }))
            .catch(err => {
                if (isValid(validationData) && !isProccessing) {
                    this.props.callback(value);
                }
            });
    }

    _setDefaultValue() {
        this.setState({
            businessName: this.props.partnerData ? this.props.partnerData.businessName : "",
            address1: this.props.partnerData ? this.props.partnerData.address1 : "",
            address2: this.props.partnerData ? this.props.partnerData.address2 : "",
            longtitude: this.props.partnerData ? this.props.partnerData.longtitude : 0,
            latitude: this.props.partnerData ? this.props.partnerData.latitude : 0,
            city: this.props.partnerData ? this.props.partnerData.city : "",
            stateValue: this.props.partnerData ? this.props.partnerData.state : "",
            countryValue: this.props.partnerData ? this.props.partnerData.country : "",
            zipCode: this.props.partnerData ? this.props.partnerData.zipCode : ""
        })
    }

    componentDidMount() {
        get("spa/getOptions", "partner", result => {
            this.setState({
                options: result
            })
        })
        this.getCity();
        this.getState();
        this.getCountry();
        this._setDefaultValue()
    }

    handleBackSubmit() {
        const value = {
            businessName: this.state.businessName,
            address1: this.state.address1,
            address2: this.state.address2,
            longtitude: this.state.longtitude,
            latitude: this.state.latitude,
            categoryID: this.refs.category_value.value,
            zipCode: this.state.zipCode
        }
        let {
            stepTwoFinish,
            stepBack
        } = this.props
        let currentData = {
            ...this.props.partnerData,
            businessName: this.state.businessName,
            address1: this.state.address1,
            address2: this.state.address2,
            longtitude: this.state.longtitude,
            latitude: this.state.latitude,
            categoryID: this.refs.category_value.value,
            zipCode: this.state.zipCode,
            city: this.state.city,
            state: this.state.stateValue,
            country: this.state.countryValue
        }
        if (stepTwoFinish) stepTwoFinish(value);
        if (stepBack) stepBack(currentData);
    }

    handleFormSubmit = (event) => {
        event.preventDefault()

        geocodeByAddress(this.state.address)
            .then(results => getLatLng(results[0]))
    }

    categoryChange() {
        this.setState({
            categoryID: this.refs.category_value.value
        })
    }

    getState() {
        get("web/state/", "", result => {
            this.setState({
                states: result
            })
        })
    }

    getCity() {
        get("web/city/", "", result => {
            this.setState({
                citys: result
            })
        })
    }
    getCountry() {
        get("web/country", "", result => {
            this.setState({
                countrys: result
            })
        })
    }


    render() {
        let {
            zipCode,
            currentAddressTab,
            countrys,
            countryValue,
            states,
            stateValue,
            citys,
            cityValue,
            address1,
            address2,
            city,
        } = this.state;
        let {
            isProccessing
        } = this.props
        let addressForDisplay = ""
        addressForDisplay = (address1 ? (address1 + ", ") : "") + (address2 ? (address2 + ", ") : "") + (city ? (city + ", ") : "") + (stateValue ? (stateValue + ", ") : "") + (countryValue ? countryValue : "")
        return (
            <div className="step_2">
                <div className="step_intro">
                    <div className="step_header">
                        <p>Business Info</p>
                    </div>
                    <div className="step_decription">
                        <p>To get started, let’s create your first user.</p>
                        <p>You can create additional users later, and this will make it easier for you to finish creating your profile.</p>
                    </div>
                </div>
                <div className="step_detail">
                    <div className="business_name">
                        <p>What is the business’ name?</p>
                        <TextIput
                            name="businessName"
                            label="Business Name"
                            showLabel={false}
                            showPlaceholder={false}
                            value={this.state.businessName}
                            validations={validationData.businessName}
                            onChange={(value) => this.setState({
                                businessName: value
                            })}
                        />
                        <div className='address_container'>
                            <label>Address</label>
                            <p id="final_address">{addressForDisplay}</p>
                            <div style={{ paddingLeft: "20px", borderLeft: "2px solid #d9c7fc", paddingBottom: "15px", marginTop: "10px" }}>
                                {
                                    (currentAddressTab === 1) ? < div >
                                        <label className="header_logo">Address Line 1: &nbsp;<i className="fa fa-map-marker" aria-hidden="true"></i></label>
                                        <input className="address_1" placeholder="Type your address" value={address1} onChange={(e) => this.setState({ address1: e.target.value })} />
                                    </div> : ""
                                }
                                {
                                    (currentAddressTab === 1) ? < div >
                                        <label className="header_logo">Address Line 2: &nbsp;<i className="fa fa-map-marker" aria-hidden="true"></i></label>
                                        <input className="address_2" placeholder="Type your address" value={address2} onChange={(e) => this.setState({ address2: e.target.value })} />
                                    </div> : ""
                                }
                                <div className="custom_address">
                                    <label className="header_logo">Your city:</label>
                                    <TextIput
                                        name="city"
                                        label="City"
                                        showLabel={false}
                                        showPlaceholder={false}
                                        value={this.state.city}
                                        validations={validationData.city}
                                        onChange={(value) => this.setState({
                                            city: value
                                        })}
                                        className="custom-form"
                                    />
                                </div>
                                <div className="custom_address">
                                    <label className="header_logo">Your state:</label>
                                    <div className="section">
                                        <VirtualizedSelect ref="stateSelect"
                                            options={states}
                                            simpleValue
                                            clearable
                                            name="select-state"
                                            value={this.state.stateValue}
                                            onChange={(value) => { this.setState({ stateValue: value }) }}
                                            searchable
                                            labelKey="name"
                                            valueKey="name"
                                        />
                                    </div>
                                </div>
                                <div className="custom_address">
                                    <label className="header_logo">Your country:</label>
                                    <div className="section">
                                        <VirtualizedSelect ref="countrySelect"
                                            options={countrys}
                                            simpleValue
                                            clearable
                                            name="select-country"
                                            value={this.state.countryValue}
                                            onChange={(value) => { this.setState({ countryValue: value }) }}
                                            searchable
                                            labelKey="name"
                                            valueKey="name"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <TextIput
                            name="zipCode"
                            label="Zip Code"
                            showLabel={true}
                            showPlaceholder={false}
                            isNumber={true}
                            value={this.state.zipCode}
                            validations={validationData.zipCode}
                            onChange={(value) => this.setState({
                                zipCode: value
                            })}
                        />
                        <div className="category_select">
                            <label>Categories</label>
                            <select ref="category_value" onChange={this.categoryChange.bind(this)}>
                                {
                                    this.state.options.categories.map((item, i) =>
                                        <option value={item.id} key={i}>{item.name}</option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className="step_footer">
                        {(!this.state.isRegisted) ? <button className="bt_back" onClick={this.handleBackSubmit.bind(this)}>Back</button> : <button className="bt_register_again" onClick={() => this.props.resetStep()}>Register again</button>}
                        {(!this.state.isRegisted) ? <button id="bt_register" className="bt_register" onClick={this.handleSubmit.bind(this)} >{!isProccessing ? "Register" : "Wait..."}</button> : <NavLink id="bt_login" to="/partner/login" className="bt_login" >Login</NavLink>}
                    </div>
                </div>
            </div >
        )
    }
}

export default StepTwo


// WEBPACK FOOTER //
// ./src/components/partner/register/stepTwo.js